module.exports = __webpack_public_path__ + "static/media/arrow-down.13b627c6.svg";